import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { MedicalItemScreeningTest } from "@/Patient/Models/MedicalSummary/MedicalItemScreeningTest";

class ScreeningTestTableItemModel implements ITableDataSourceItem<MedicalItemScreeningTest> {
    public Model: MedicalItemScreeningTest;
    public Name: string;

    constructor(model: MedicalItemScreeningTest) {
        this.Model = model;
        this.Name = this.Model.getMedicalItem().Id;
    }
}

export { ScreeningTestTableItemModel };
